import {connect} from 'react-redux';
import IndicativeSellingPrice from './IndicativeSellingPrice';

const mapStateToProps = (state) => ({
  propertyDetail: state.propertyDetail,
  indicativeSellingPrice: state.indicativeSellingPrice,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch,
});

export default connect(mapStateToProps, mapDispatchToProps)(IndicativeSellingPrice);